import {Injectable} from '@angular/core';
import {BaseService} from '../../base-service';
import {ApiConfiguration} from '../../api-configuration';
import {HttpClient, HttpHeaders, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {StrictHttpResponse} from '../../strict-http-response';
import {UpdateLeadRequest} from '../../models/update-lead-request';
import {UpdateLeadResponse} from '../../models/update-lead-response';
import {RegisterNewLeadRequest} from '../../models/register-new-lead-request';
import {RegisterNewLeadResponse} from '../../models/register-new-lead-response';

@Injectable({
  providedIn: 'root',
})
export class GapLeadsService extends BaseService {

  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  registerLead(registerLeadRequest: RegisterNewLeadRequest): Observable<RegisterNewLeadResponse> {
    return this._registerLeadPostResponse(registerLeadRequest).pipe(
      map(response => response.body as RegisterNewLeadResponse)
    );
  }

  private _registerLeadPostResponse(registerLeadRequest: RegisterNewLeadRequest): Observable<HttpResponse<RegisterNewLeadResponse>> {
    const req = new HttpRequest<RegisterNewLeadRequest>(
      'POST',
      `${this.rootUrl}/gapLeads/register`,
      registerLeadRequest,
      {
        headers: new HttpHeaders(),
        params: this.newParams(),
        responseType: 'json'
      });

    return this.http.request<RegisterNewLeadRequest>(req).pipe(
      filter(event => event instanceof HttpResponse),
      map(response => response as HttpResponse<RegisterNewLeadResponse>)
    );
  }

  updateLead(updateLeadRequest: UpdateLeadRequest): Observable<UpdateLeadResponse> {
    return this._updateLeadPostResponse(updateLeadRequest).pipe(
      map(response => response.body as UpdateLeadResponse)
    );
  }

  private _updateLeadPostResponse(updateLeadRequest: UpdateLeadRequest): Observable<StrictHttpResponse<UpdateLeadResponse>> {
    const req = new HttpRequest<UpdateLeadRequest>(
      'POST',
      `${this.rootUrl}/gapLeads/updateLead`,
      updateLeadRequest,
      {
        headers: new HttpHeaders(),
        params: this.newParams(),
        responseType: 'json'
      });

    return this.http.request<UpdateLeadResponse>(req).pipe(
      filter(event => event instanceof HttpResponse),
      map(response=> response as HttpResponse<UpdateLeadResponse>)
    );
  }
}
